<template>
    <div class="site__body">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <router-link to="/order-parts" class="breadcrumb__item-link">Order Parts</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                        <span class="breadcrumb__item-link">Alternate Products</span>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>
                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Compare Alternate Products</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block">
            <div class="container">
                <compare-alternates-table></compare-alternates-table>
            </div>
            </div>
    </div>
    <div class="block-space block-space--layout--before-footer"></div>
</template>

<script>

import CompareAlternatesTable from './CompareAlternatesTable';

export default {
    name: 'CompareAlternates',
    components: {
        CompareAlternatesTable    
    },

    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
    }
}
</script>